module.exports = __webpack_public_path__ + "static/img/icon_plus.99e714da.svg";